export default __webpack_public_path__ + "static/suites_image_one-9f7db2355aaddcdf3d6f827cbef110d0.jpg";